// store.js
import Vue from 'vue'
import { EventBus } from './bus.js'
import Vuex from 'vuex'
Vue.use(Vuex)

// app initial state
const state = {
  socket: {
    is_connected: false,
    message: '',
    reconnect_error: false
  },
  count: 0,
  empty_user: {
    username: '',
    balance: 0,
    progress: {}
  },
  user: {
    username: '',
    balance: 0,
    progress: {}
  },
  session: {
    session_id: ''
  },
  show_menu: false,
  debug: true,
  pdd_oid: '5ac0f57112df2203d397dc4c'
}

// define possible mutations
const mutations = {
  set_user (state, user) {
    state.user = user
  },
  set_show_menu (state, s) {
    state.show_menu = s
  },
  INCREMENT (state) {
    state.count++
  },
  DECREMENT (state) {
    state.count--
  },
  SOCKET_ONOPEN (state, event) {
    state.socket.is_connected = true
  },
  SOCKET_ONCLOSE (state, event) {
    state.socket.is_connected = false
  },
  SOCKET_ONERROR (state, event) {
    console.error('socket', 'on_error', state, event)
    EventBus.$emit('ws_on_error', event)
  },
  SOCKET_RECONNECT (state, count) {
    console.info('socket', 'reconnect', state, count)
  },
  SOCKET_RECONNECT_ERROR (state) {
    console.socket.reconnect_error = true
    console.error('socket', 'reconnect')
  },
  SOCKET_ONMESSAGE (state, event) {
    EventBus.$emit('ws_on_message', event.data)
  },
  ws_send (state, msg) {
    console.log(this.$socket)
  }
}

// create the store
export default new Vuex.Store({
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/store.js